import React from 'react';
import { DesktopDatePicker } from '@mui/x-date-pickers';
import classNames from 'classnames';
import dayjs, { Dayjs } from 'dayjs';

import { dateInputFieldFormat, datePickerDisplayFormat } from '~libs/dayjs';

import { InputProps } from '../props';

interface ComponentProps extends InputProps {
  minDate?: string | Dayjs;
  maxDate?: string | Dayjs;
  displayFormat?: string;
}

const DateInput: React.FC<ComponentProps> = ({
  id,
  value,
  placeholder,
  disabled = false,
  className,
  onChange,
  name,
  dataCy = null,
  minDate,
  maxDate,
  displayFormat = datePickerDisplayFormat,
}) => {
  const dateValue = value ? dayjs(value, dateInputFieldFormat) : null;

  const setChange = (value: Dayjs | null) => {
    onChange && onChange(id, value ? value.format(dateInputFieldFormat) : null);
  };

  const dateClass = classNames('form-control', {
    [`${className}`]: className != undefined,
  });

  let dataCyId = `${id}-date`;
  if (dataCy) dataCyId = `${dataCy}-${dataCyId}`;

  return (
    <DesktopDatePicker
      value={dateValue}
      disabled={disabled}
      label={placeholder}
      name={name}
      format={displayFormat}
      className={dateClass}
      minDate={minDate ? dayjs(minDate, dateInputFieldFormat) : undefined}
      maxDate={maxDate ? dayjs(maxDate, dateInputFieldFormat) : undefined}
      slotProps={{
        field: { shouldRespectLeadingZeros: true },
        textField: {
          inputProps: { 'data-cy': dataCyId },
          size: 'small',
        },
        actionBar: { actions: ['clear', 'today'] },
      }}
      onChange={(value) => setChange(value)}
    />
  );
};

export default DateInput;
